<div class="news-page">
  <div class="container py-5">
    
    <!-- Page Header -->
    <div class="page-header text-center mb-5" data-aos="fade-down">
      <h1 class="page-title">
        <i class="fa-solid fa-newspaper mx-2"></i>
        أحدث الأخبار
      </h1>
      <p class="page-subtitle">تابع آخر الأخبار والمستجدات من مدينة الغردقة</p>
    </div>

    <!-- Loading -->
    <div class="text-center my-5" *ngIf="loading">
      <app-loading></app-loading>
    </div>

    <!-- Error Message -->
    <div class="alert alert-danger text-center" *ngIf="errorMessage && !loading" role="alert">
      <i class="fa-solid fa-circle-exclamation me-2"></i>
      {{ errorMessage }}
    </div>

    <!-- No News Found -->
    <div class="empty-state text-center py-5" *ngIf="!loading && !errorMessage && newsList.length === 0" data-aos="fade-up">
      <i class="fa-solid fa-inbox empty-icon"></i>
      <h3 class="empty-title">لا توجد أخبار حالياً</h3>
      <p class="empty-text">سيتم إضافة الأخبار قريباً</p>
    </div>

    <!-- Categories Filter -->
    <div class="filter-section mb-5" *ngIf="!loading && categories.length > 0" data-aos="fade-up">
      <div class="filter-wrapper">
        <label for="categoryFilter" class="filter-label">
          <i class="fa-solid fa-filter mx-2"></i>
          تصفية حسب القسم
        </label>
        <div class="select-wrapper">
          <select 
            id="categoryFilter"
            class="category-select"
            [(ngModel)]="selectedCategory"
            (ngModelChange)="onCategoryChange()"
          >
            <option value="all">عرض جميع الأخبار ({{ newsList.length }})</option>
            <option *ngFor="let category of categories" [value]="category">
              {{ category }} ({{ getCategoryCount(category) }})
            </option>
          </select>
          <i class="fa-solid fa-chevron-down select-icon"></i>
        </div>
        <div class="filter-results" *ngIf="selectedCategory !== 'all'">
          <span class="results-text">
            عرض {{ newsCount }} من {{ newsList.length }} خبر
          </span>
        </div>
      </div>
    </div>

    <!-- News Grid -->
    <div class="row g-4" *ngIf="!loading && filteredNews.length > 0">
      <div class="col-lg-4 col-md-6" *ngFor="let item of filteredNews" data-aos="zoom-in">
        <a [routerLink]="['/news', item.id]" class="news-card-link">
          <div class="news-card h-100">
            
            <!-- News Image -->
            <div class="news-image-wrapper">
              <img
                *ngIf="item.image"
                [src]="item.image"
                class="news-image"
                [alt]="item.title"
              />
              <div class="image-overlay"></div>
              <span class="category-badge">{{ item.category }}</span>
              <div class="read-more-badge">
                <i class="fa-solid fa-arrow-left mx-2"></i>
                اقرأ المزيد
              </div>
            </div>

            <div class="news-card-body">
              
              <!-- Title -->
              <h3 class="news-title">{{ item.title }}</h3>

              <!-- Article snippet -->
              <p class="news-excerpt">
                {{ (item.article || '') | slice:0:120 }}...
              </p>

              <!-- Meta Information -->
              <div class="news-meta">
                <div class="meta-item">
                  <i class="fa-solid fa-clock mx-1"></i>
                  <span>{{ item.createdAt | date:'medium' }}</span>
                </div>
                <div class="meta-divider"></div>
                <div class="meta-item">
                  <i class="fa-solid fa-folder mx-1"></i>
                  <span>{{ item.category }}</span>
                </div>
              </div>

            </div>

          </div>
        </a>
      </div>
    </div>

    <!-- Loading More Indicator -->
    <div class="text-center my-4" *ngIf="loadingMore">
      <app-loading></app-loading>
      <p class="text-muted mt-2">جاري تحميل المزيد من الأخبار...</p>
    </div>

    <!-- Pagination -->
    <div class="pagination-section mt-5" *ngIf="!loading && newsList.length > 0 && selectedCategory === 'all'">
      <nav aria-label="News pagination">
        <ul class="pagination justify-content-center">
          <!-- Previous Button -->
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" (click)="goToPage(currentPage - 1)" [attr.aria-disabled]="currentPage === 1">
              <i class="fa-solid fa-chevron-right mx-1"></i>
              السابق
            </a>
          </li>

          <!-- First Page -->
          <li class="page-item" *ngIf="currentPage > 3 && totalPages > 5">
            <a class="page-link" (click)="goToPage(1)">1</a>
          </li>
          <li class="page-item disabled" *ngIf="currentPage > 3 && totalPages > 5">
            <span class="page-link">...</span>
          </li>

          <!-- Page Numbers -->
          <li 
            class="page-item" 
            *ngFor="let page of getPageNumbers()"
            [class.active]="page === currentPage"
          >
            <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
          </li>

          <!-- Last Page -->
          <li class="page-item disabled" *ngIf="currentPage < totalPages - 2 && totalPages > 5">
            <span class="page-link">...</span>
          </li>
          <li class="page-item" *ngIf="currentPage < totalPages - 2 && totalPages > 5">
            <a class="page-link" (click)="goToPage(totalPages)">{{ totalPages }}</a>
          </li>

          <!-- Next Button -->
          <li class="page-item" [class.disabled]="!hasMore">
            <a class="page-link" (click)="goToPage(currentPage + 1)" [attr.aria-disabled]="!hasMore">
              التالي
              <i class="fa-solid fa-chevron-left mx-1"></i>
            </a>
          </li>
        </ul>
      </nav>

      <!-- Page Info -->
      <div class="pagination-info text-center mt-3">
        <p class="mb-0">
          عرض {{ (currentPage - 1) * 10 + 1 }} - {{ Math.min(currentPage * 10, totalNews) }} من {{ totalNews }} خبر
        </p>
      </div>
    </div>

    <!-- Load More Button (Alternative to pagination) -->
    <div class="load-more-section text-center mt-4" *ngIf="!loading && hasMore && selectedCategory === 'all' && currentPage === 1">
      <button class="btn-load-more" (click)="loadMoreNews()" [disabled]="loadingMore">
        <i class="fa-solid fa-arrow-down mx-2" [class.fa-spin]="loadingMore"></i>
        {{ loadingMore ? 'جاري التحميل...' : 'تحميل المزيد من الأخبار' }}
      </button>
    </div>

    <!-- No Results for Selected Category -->
    <div class="empty-state text-center py-5" *ngIf="!loading && filteredNews.length === 0 && newsList.length > 0" data-aos="fade-up">
      <i class="fa-solid fa-filter-circle-xmark empty-icon"></i>
      <h3 class="empty-title">لا توجد أخبار في هذا القسم</h3>
      <p class="empty-text">جرب اختيار قسم آخر أو عرض جميع الأخبار</p>
      <button class="btn-reset-filter" (click)="selectedCategory = 'all'; onCategoryChange()">
        <i class="fa-solid fa-rotate-right mx-2"></i>
        عرض جميع الأخبار
      </button>
    </div>

  </div>
</div>
  